/**
 * @mixin gameMixin
 * @desc 初級・中級レベルゲーム共通メソッド
 */
export default {
  methods: {
    /**
     * ルーレット画面を閉じる
     */
    closeView () {
      this.stopRouletteSound()
      this.rouletteStopSounds = null
      this.$router.push(this.back_page)
    },

    /**
     * ゲーム終了チェック
     * @return {Boolean} true/false カード総数に達する
     */
    gameIsFinished () {
      return this.displayedIndex.length >= this.maxCount
    },

    /**
     * ルーレット項目のON/OFF
     */
    toggleState (item) {
      this[item] = !this[item]
    },

    /**
     * ルーレットスタート
     */
    playGame () {
      // ストップ音がプログラム操作で再生できるようにように最初だけ鳴らす
      if (this.displayedIndex.length === 0) {
        this.playStopSound()
      }

      if (!this.rouletteIsDisplayed()) {
        alert("1つ以上のアイテムにチェックを入れてください。")
        return
      }

      if (this.timerIsRunnig()) {
        return
      }

      if (this.gameIsFinished()) {
        this.showFinishAlert()
        return
      }

      let randnum = this.getRandomNum() // ランダムIDの取得
      if (!randnum) {
        return
      }
      this.currentDataIndex = randnum
      this.displayedIndex.push(randnum)
      this.start_btn_label = "ルーレット中！"
      this.answer_btn_show = false
      this.checkbox_disable = true
      this.isActive = false
      this.imgs_show = true
      this.startTimers()
      this.playRouletteSound()
    },

    /**
     * 未使用のランダムなIDを返す
     * @return {Number} randnum
     */
    getRandomNum () {
      let randnum = 0
      randnum = Math.floor(Math.random() * this.maxCount)
      while (this.checkDisplayed(randnum)) {
        randnum = Math.floor(Math.random() * this.maxCount)
      }
      return randnum
    },

    /**
     * ランダムで生成した整数が表示済みリストにないかチェックする
     * @param {Number} nextIndex
     * @return {Boolean} true/false
     */
    checkDisplayed (nextIndex) {
      return this.displayedIndex.includes(nextIndex)
    },

    /**
     * リセットボタンイベント
     * 確認ポップアップを表示する
     */
    resetGame () {
      if (this.timerIsRunnig()) {
        return
      }
      this.playPopupSound()
      this.animation = "flip"
      this.reset_alert_show = true
    },

    /**
     * 国／県形イメージをルーレット中のgifに変更する
     */
    changeShapeImage () {
      this.shape_title_src = ""
      this.shape_img_src = this.shape_roulette_anime
    },

    /**
     * 国／県名テキストをランダムで取得して表示
     */
    changeName () {
      const randnum = Math.floor(Math.random() * this.maxCount)
      const current = this.data[randnum]
      this.name_src = current.name
    },

    /**
     * ゲーム終了ポップアップを表示
     */
    showFinishAlert () {
      this.playPopupSound()
      this.animation = "slideDown"
      this.finish_alert_show = true
    },

    /**
     * ルーレットを再スタート
     */
    nextGame () {
      this.answer_view_show = false
      this.playGame()
    },

    /**
     * ルーレットストップ時の画面の更新
     * <ul>
     * <li>すべてのルーレットが止まったら以下の処理を実行</li>
     * <li>スタートボタンのラベルを状態に応じて変更</li>
     * <li>残りの数を更新</li>
     * <li>正解ボタンを非表示</li>
     * <li>リセットボタンなどの非アクティブ状態を解除</li>
     * </ul>
     */
    updateVCtrlBtns () {
      if (this.timerIsRunnig()) {
        return
      }
      if (this.gameIsFinished()) {
        this.start_btn_label = "ゲーム終了！"
        return
      }
      this.stopRouletteSound()
      this.start_btn_label = "Next！"
      this.rest = this.maxCount - this.displayedIndex.length
      this.answer_btn_show = true
      this.isActive = true
      this.checkbox_disable = false
    },

    /**
     * 国／都道府県名のタイマーを破棄して正解のテキストを表示
     */
    stopNameTimer () {
      clearInterval(this.nameTimer)
      this.nameTimer = null
      const current = this.data[this.currentDataIndex]
      this.name_src = current.name
      this.playStopSound()
      this.updateVCtrlBtns()
    }
  }
}
